import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
name: 'replaceStatus'
})
export class ReplaceStatusPipe implements PipeTransform {

transform(status: string=''): any {
if(status != null) {
 let value=status.split('_').join(' ');;
status=value.trim().toLowerCase().replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase())));
} else{
let value=status;
}
    return status;
  }
}
